import React from 'react';
import ReactDOM from 'react-dom';
class BuildFeed extends React.Component {
  	constructor(props) {
		super(props);
		
    	
	}
	render() {
		console.log(this.props.items);
		return(
			this.props.items.map((answer, i) => {     
		        
				var url = answer['media:content'][0]['$']['url'];  
				var str = String(answer.title);
				var author = answer['dc:creator'];
				var new_str = (str.length > 80 )?str.substring(0, 80)+'...':str;
 				var guid = answer.guid[0];
		       // Return the element. Also pass key     
		       return <div className="card" key={answer.title}>
					<div className="row no-gutters">
						<div className="col-auto">
						    <img src={url} className="img-fluid card-img-top" alt="" />							
						</div>
						<div className="col">
						    <div className="card-block px-2">
						        <h4 className="card-title"><a href={answer.link}>{new_str}</a></h4>
								<p className="card-text author_text">{author}</p>
						        <p className="card-text feed-item-date">{answer.pubDate}</p>
						    </div>
						</div>
					</div>					
			  </div> ; 
		    })

			 )
			
		    
		
	}
}

export default BuildFeed;
